export const splitTagsRegex = /\[#(\w*)\]\{(\d*)\}/g;
export function cleanTextFromTags(str: string) {
  if (!str) return str;
  return str.replaceAll(splitTagsRegex, '#$1');
}
